<template>
    <VueFinalModal
        class="flex items-center justify-center p-4"
        content-class="relative flex flex-col w-full max-w-6xl bg-gray-100 dark:bg-subtle rounded-lg shadow-2xl"
        overlay-transition="vfm-fade"
        content-transition="vfm-fade"
        :click-to-close="true"
        :esc-to-close="true"
        @close="close"
    >
        <div class="p-6" tabindex="-1">
            <!-- Modal Header -->
            <div class="flex justify-between items-center mb-6">
                <h2 class="text-2xl font-bold text-gray-800 dark:text-txt-headings">Foto / video galéria</h2>
                <button 
                    aria-label="Close modal" 
                    class="text-3xl text-gray-600 dark:text-txt-body hover:text-gray-800 hover:dark:text-txt-headings transition-colors"
                    @click="close"
                >
                    ×
                </button>
            </div>

            <div class="relative bg-white dark:bg-surface-card rounded-lg border-2 border-gray-200 dark:border-default overflow-hidden">
                <button
                    class="absolute left-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center size-12 bg-white/90 dark:bg-surface-card/90 hover:bg-white hover:dark:bg-surface-card rounded-full shadow-lg transition-all duration-300 hover:shadow-xl"
                    @click="previousItem"
                >
                    <CIcon class="text-gray-700 dark:text-txt-body rotate-180" name="next" />
                </button>

                <button
                    class="absolute right-4 top-1/2 -translate-y-1/2 z-10 flex items-center justify-center size-12 bg-white/90 dark:bg-surface-card/90 hover:bg-white hover:dark:bg-surface-card rounded-full shadow-lg transition-all duration-300 hover:shadow-xl"
                    @click="nextItem"
                >
                    <CIcon class="text-gray-700 dark:text-txt-body" name="next" />
                </button>

                <div class="relative min-h-[500px] flex items-center justify-center">
                    <img 
                        v-if="imageIndexToShow < images.length" 
                        class="w-full h-auto max-h-[600px] object-contain" 
                        :src="gallery[imageIndexToShow]" 
                        :alt="`Gallery image ${imageIndexToShow + 1}`"
                    />

                    <CEmbedVideo 
                        v-else 
                        class="max-w-full h-full flex items-center justify-center" 
                        :src="gallery[imageIndexToShow]"
                        :no-aspect-ratio="true"
                    />
                </div>
            </div>

            <div class="text-center text-gray-500 dark:text-txt-body">{{ imageIndexToShow + 1 }} / {{ gallery.length }}</div>
        </div>
    </VueFinalModal>
</template>

<script setup lang="ts">
import { VueFinalModal } from 'vue-final-modal'

const props = defineProps<{
    images: string[]
    videos: string[]
    initialIdx?: number
}>()

const emit = defineEmits(['close'])

const imageIndexToShow = ref(props.initialIdx || 0)

const gallery = computed(() => {
    return props.images.concat(props.videos)
})

const close = () => {
    emit('close')
}

const nextItem = () => {
    if (imageIndexToShow.value === gallery.value.length - 1) {
        imageIndexToShow.value = 0
    } else {
        imageIndexToShow.value++
    }
}

const previousItem = () => {
    if (imageIndexToShow.value === 0) {
        imageIndexToShow.value = gallery.value.length - 1
    } else {
        imageIndexToShow.value--
    }
}
</script>